// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__3wsvF","Gradient":"styles_Gradient__Ngt0q"};